<template>
    <div class="tw-grid tw-gap-4 xl:tw-gap-12 tw-auto-rows-max tw-grid-cols-1 xl:tw-grid-cols-3">
        <div v-for="type in types" :key="type" class="tw-flex tw-flex-col">
            <h5 class="tw-text-lg tw-font-semibold tw-text-gray-700 tw-m-0 tw-mb-4">
                {{ $t(`feedback.analytics.totals.${type}`) }}
                <i
                    v-if="type === 'feedbackReceivedCount'"
                    v-b-popover.top.hover="$t('feedback.analytics.totals.receivedCountHint')"
                    class="far fa-info-circle tw-ml-1"
                />
            </h5>

            <div
                class="tw-flex-1 tw-flex tw-items-center tw-p-5 tw-rounded-2xl tw-overflow-hidden tw-border tw-border-solid tw-border-gray-200"
            >
                <div
                    class="tw-flex tw-flex-grow-0 tw-items-center tw-justify-start tw-text-gray-800 tw-text-3xl"
                >
                    <div
                        class="tw-p-2 tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-align-middle tw-bg-gray-50 tw-rounded-lg tw-mr-5 tw-text-indigo-500"
                    >
                        <i
                            class="fal tw-text-lg"
                            :class="{
                                'fa-comment-lines': type === 'feedbackSentCount',
                                'fa-award': type === 'feedbackReceivedCount',
                                'fa-repeat': type === 'feedbackRequestedCount',
                            }"
                        />
                    </div>
                    <div class="tw-font-bold">{{ stats[type].total }}x</div>
                </div>

                <div
                    v-if="['feedbackSentCount', 'feedbackReceivedCount'].includes(type)"
                    class="tw-flex-1 tw-flex tw-flex-wrap tw-ml-5"
                >
                    <div class="tw-flex-initial tw-text-sm tw-inline-block tw-pr-3">
                        {{ $t("feedback.analytics.totals.feedback") }}
                        <span class="tw-text-indigo-500 tw-font-bold">
                            {{ stats[type].feedback }}x
                        </span>
                    </div>
                    <div class="tw-flex-initial tw-text-sm tw-inline-block">
                        {{ $t("feedback.analytics.totals.praise") }}
                        <span class="tw-text-indigo-500 tw-font-bold">
                            {{ stats[type].praise }}x
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        stats: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            types: ["feedbackSentCount", "feedbackReceivedCount", "feedbackRequestedCount"],
        };
    },
};
</script>
